import React, { Component, useEffect, useState } from "react";
import * as Constants from "../../Constants/index"
import axios from "axios";
import swal from "sweetalert";
import SimpleReactValidator from "simple-react-validator";
import Switch from "react-switch";
import ReactDragListView from "react-drag-listview";
import LoadingButton from "../common/LoadingButton";

class CreateConfiguration extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      name: this.props.resp ? this.props.resp.data.output.name : "",
      value: this.props.resp ? this.props.resp.data.output.value : "",
      description: this.props.resp ? this.props.resp.data.output.description : "",
      sortBy: "name",
      limit: 1000,
      page: 1,
      searchTerm: "",
      search: "",
      create: 1,
      submitting: false,
    };
  }

  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount()
    );
  };
  nameHandleChange = (event) => {
    this.setState({ name: event.target.value });
  };
  valueHandleChange = (event) => {
    this.setState({ value: event.target.value });
  };
  descriptionHandleChange = (event) => {
    this.setState({ description: event.target.value });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ submitting: true });
      const token = localStorage.getItem("token");

      if (this.props.resp) {
        axios
          .patch(
            Constants.api + "master/config/" + this.props.resp.data.output.id,
            {
              "name": this.state.name,
              "value": this.state.value,
              "description": this.state.description,

            },
            {
              headers: { Authorization: `Bearer ${token}`, company: 0, program: 0, appVersion: Constants.av, },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              swal("Configuration Updated");
              this.setState({ create: 0 });
            } else if (res.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .catch((err) => {
            //localStorage.clear();
            //    window.location = "/login"
          })
          .finally(() => {
            this.setState({ submitting: false });
          });;
      } else {
        axios
          .post(
            Constants.api + "master/config",
            {
              "name": this.state.name,
              "value": this.state.value,
              "description": this.state.description
            },
            {
              headers: { Authorization: `Bearer ${token}`, company: 0, program: 0, appVersion: Constants.av },
            }
          )
          .then((res) => {
            if (res.status == 201) {
              swal("Configuration Added");
              this.setState({ create: 0 });

            }  else if (res.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .catch((err) => {
            //localStorage.clear();
            //    window.location = "/login"
          })
          .finally(() => {
            this.setState({ submitting: false });
          });;
      }
    } else {
      this.setState({ submitting: false });
      this.validator.showMessages();
    }
    this.forceUpdate();
  };

  render() {

    if (this.state.create == 0) {
      window.location = "/configurations";
    }

    let search = this.state.search;

    return (
      <>
        <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
          <nav class="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
            <div class="container-fluid py-1 px-3">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">

                  <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark" href="javascript:;">Configurations</a></li>
                  <li class="breadcrumb-item text-sm text-dark active" aria-current="page">Add New</li>
                </ol>
              </nav>
              <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                <a href="javascript:;" class="nav-link text-body p-0">
                  <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </div>

            </div>
          </nav>
          <div class="card mt-4" id="basic-info">
            <div class="card-header">
              <h5>Settings</h5>
            </div>
            <form onSubmit={this.handleFormSubmit}>
              <div class="card-body pt-0">

                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label mt-4">Name</label>
                    <input class="form-control" id="choices-skills" type="text" placeholder="" name="name" value={this.state.name} onChange={this.nameHandleChange} />
                    {this.validator.message(
                      " Name",
                      this.state.name,
                      "required"
                    )}
                  </div>
                </div>
                <div class="row">

                  <div class="col-md-4">
                    <label class="form-label mt-4">Values</label>
                    <textarea class="form-control" id="choices-skill" type="text" placeholder="" name="value" onChange={this.valueHandleChange} value={this.state.value} ></textarea>
                    {this.validator.message(
                      "Value",
                      this.state.value,
                      "required"
                    )}
                  </div>
                </div>
                <div class="row">

                  <div class="col-md-4">
                    <label class="form-label mt-4">Description</label>
                    <textarea class="form-control" id="choices" type="text" placeholder="" name="description" onChange={this.descriptionHandleChange} value={this.state.description}  ></textarea>
                    {this.validator.message(
                      "Description",
                      this.state.description,
                      "required"
                    )}
                  </div>
                </div>



                <div class=" mt-4" id="delete">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-sm-0 mb-4">
                      <div class="w-50">
                        {/* <p>Save Country</p> */}
                        {/* <p class="text-sm mb-0">Once you delete your account, there is no going back. Please be certain.</p> */}
                      </div>
                      <div class="w-50 text-end">
                        <button class="btn btn-outline-secondary mb-3 mb-md-0 ms-auto" type="button" name="button" onClick={() => this.setState({ create: 0 })}>Cancel</button>
                        <LoadingButton class="btn bg-gradient-success mb-0 ms-2" type="submit" name="button" loading={this.state.submitting}>Save </LoadingButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </main >

      </>
    );
  }

}

export default CreateConfiguration;
